import { DataGrid, ruRU as gridRuRU } from '@mui/x-data-grid'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { DataGridWrapper, GridCell } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { GridRow } from './types'

type ListProps = {
  rows: GridRow[]
}

export const List = ({ rows }: ListProps) => {
  const { t } = useTranslation()

  return (
    <DataGridWrapper
      sx={{
        height: '508px',
      }}
    >
      <DataGrid
        density='compact'
        columns={columns.map((column) => ({
          ...column,
          headerName: t(column.headerName as ParseKeys),
        }))}
        pageSize={30}
        rows={rows}
        hideFooter
        disableColumnMenu
        disableSelectionOnClick
        disableColumnSelector
        localeText={gridRuRU.components.MuiDataGrid.defaultProps.localeText}
        sortingMode='server'
        components={{
          Cell: GridCell,
        }}
      />
    </DataGridWrapper>
  )
}
